import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/crm/auth.service';
import swal from 'sweetalert2';  

@Component({
  selector: 'app-usuario',
  templateUrl: './usuario.component.html',
  styleUrls: ['./usuario.component.css']
})
export class UsuarioComponent implements OnInit {

  constructor(public authService: AuthService,public router:Router) { }
  public loading = false;
  
  facturas;
  ngOnInit(): void {
    this.ls_usuarios();
    this.ls_cliente();
    this.get_org();
    try {
      this.facturas=localStorage.getItem("facturas");  
      this.id_cliente=Number(localStorage.getItem("id_cliente"))  
    } catch (error) {
      this.facturas=0;
    }
    this.ls_matriz();
  }
  bndmnugral=true;
    oculta_menu(){
      console.log("-");
      if(this.bndmnugral==true){
        this.bndmnugral=false;
      }else{
        this.bndmnugral=true;
      }
      console.log(this.bndmnugral);
    }
  bndmodulos=false;
  v_modulos(){
    if(this.bndmodulos=true){
      this.bndmodulos=false;
    }else{
      this.bndmodulos=true;
    }
  }
  onChange_modulo(cliente,modulo,usuario){
    //console.log(usuario)
    let postData={
      cliente:cliente,
      modulo:modulo,
      usuario:usuario
    };    
       
    this.authService.service("/api/matriz_permisos",postData)
    .then(
      data => {
  
        swal.fire('¡ok!', '', 'success');
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! matriz_permisos', '', 'error');
    }); 

  }

  
  value_check(modulos,itmm){
    //console.log(modulos)
    //console.log(itmm)
    var c=modulos.toString().split(",");
    if(c.length>0){
      for(var i=0;i<c.length;i++){
        if(c[i]==itmm){
          return true
        }
      }
    }
    return false;
  }
  matriz=[];
  ls_matriz(){
    let postData={
    };    
    this.loading=true;    
    this.authService.service("/api/permisos",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);         
        this.loading=false;
        this.matriz=data;
        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_usuarios', '', 'error');
    }); 
  }
  edtUsu=false;
  usuarios:any;
  ls_usuarios(){ 
    this.edtUsu2=false;   
    this.edtUsu=false;    
    let postData={
      id_cliente:Number(localStorage.getItem("id_cliente"))
    };    
    this.loading=true;    
    this.authService.service("/api/get_usuarios_cliente",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat); 
        
        this.loading=false;
        this.usuarios=data;
        
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_usuarios', '', 'error');
    }); 
  }
  org;
  get_org(){
    let postData = {
      id_cliente:localStorage.getItem("id_cliente")
    } 
      //console.log(postData);
      this.authService.service("/api/get_org",postData)
      .then(
          data => {
            var dat = JSON.stringify(data);
            var res = JSON.parse(dat);    
            this.org=data;
              //console.log(data);
          },
          error => {
              var de= JSON.stringify(error);
              var di = JSON.parse(de)
              swal.fire('¡API incorrecta! exp', '', 'error');
          });   
    }
  usuario={
    id:0,
    nombre:"",
    sufijo:"",
    login:"",
    password:"",
    facturas:0,
    estado:"",
    email:"",
    cliente:0,
    id_role:0
  }
  edtUsu2;
  bndnvo=false;
  nvo_usu(){
    this.usuario.id_role=0;
    this.usuario.email="";
    this.usuario.id=0;
    this.usuario.nombre="";
    this.usuario.sufijo="";
    this.usuario.login="";
    this.usuario.password="";
    this.usuario.estado="";
    this.edtUsu=true;
    this.edtUsu2=false
    this.bndnvo=true ;
  }
  cangda(){
    this.edtUsu=false;
    this.edtUsu2=false;
  }
  edt_usu(itm){
    //console.log(itm); 
    this.usuario.id_role=itm.id_role;
    this.usuario.id=itm.id;
    this.usuario.nombre=itm.nombre;
    this.usuario.sufijo=itm.sufijo;
    this.usuario.login=itm.login;
    this.usuario.password=itm.password;
    this.usuario.estado=itm.estado;
    this.usuario.facturas=itm.facturas;
    this.usuario.email=itm.email;
    this.usuario.cliente=Number(itm.cliente)
    this.edtUsu=true;
    this.bndnvo=false;
    this.edtUsu2=true;
    this.ls_pms();
  }
  pms:any;
  id_cliente:any;
  add_pms(){
    let postData={
      id_usuario:this.usuario.id,
      id_cliente:this.id_cliente
    };    
    this.loading=true;  
    //console.log(postData);  
    this.authService.service("/api/gda_pms",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);         
        this.loading=false;
        this.ls_pms();
        swal.fire('¡Ok', '', 'success');   
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_pms', '', 'error');
    }); 

  }
  ls_pms(){
    let postData={
      id_usuario:this.usuario.id
    };    
    this.loading=true;  
    //console.log(postData);  
    this.authService.service("/api/get_pms",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);         
        this.loading=false;
        this.pms=res;   
        //console.log(res)     
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_pms', '', 'error');
    }); 

  }
  gda_usu(){
    if(this.usuario.id_role==0)return;
    let postData={
      nombre:this.usuario.nombre,
      sufijo:this.usuario.sufijo,
      login:this.usuario.login,
      facturas:Number(this.usuario.facturas),
      password:this.usuario.password,
      estado:this.usuario.estado,
      id:this.usuario.id,
      email:this.usuario.email,
      id_cliente:Number(this.id_cliente),
      id_role:this.usuario.id_role
    }
    this.loading=true;
    
    this.authService.service("/api/ins_usuarios_cliente",postData)
    .then(
      data => {
        this.loading=false;
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat); 

        let postDatapms={
          id_usuario:res.insertId,
          id_cliente:this.id_cliente
        }        
        this.authService.service("/api/gda_pms",postDatapms)
        .then(data => {});   
        this.ls_usuarios();            
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_usuarios', '', 'error');
    });
  }
  fn_q(itm){
    let postData={
      id:itm.id
    };    
    this.loading=true;    
    this.authService.service("/api/del_pms",postData)
    .then(
      data => {
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat);                 
        this.ls_pms();
        swal.fire('¡ok', '', 'success');
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_usuarios', '', 'error');
    }); 

  }
  clientes;
  ls_cliente(){
    this.loading=true;
    this.clientes=[];
    let postData=[];
    this.authService.service("/api/get_cliente",postData)
    .then(
        data => {
          var dat = JSON.stringify(data);
          var res = JSON.parse(dat);                      
          //console.log(data);
          this.clientes=data;
          this.loading=false; 
        },
        error => {
            var de= JSON.stringify(error);
            var di = JSON.parse(de)
            swal.fire('¡API incorrecta! ', '', 'error');
        });   

  }
  guarda(){
    let postData={
      nombre:this.usuario.nombre,      
      sufijo:this.usuario.sufijo,
      login:this.usuario.login,
      facturas:Number(this.usuario.facturas),
      password:this.usuario.password,
      estado:this.usuario.estado,
      id:this.usuario.id,
      email:this.usuario.email,
      cliente:Number(this.usuario.cliente),
      id_role:this.usuario.id_role
    }
    console.log(postData)
    this.loading=true;
    this.authService.service("/api/upd_usuarios_role",postData)
    .then(
      data => {
        this.loading=false;
        var dat = JSON.stringify(data);
        var res = JSON.parse(dat); 
        this.ls_usuarios();            
      },
      error => {
          var de= JSON.stringify(error);
          var di = JSON.parse(de)
          this.loading=false;
          swal.fire('¡API incorrecta..! ls_usuarios', '', 'error');
    });     
  }
}
